import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { RATINGS } from '../../../../lib/schema.js';
import RatingLabel from '../../../RatingLabel.jsx';

StakeholderSupportsFilter.defaultProps = {
  selectedStakeholderSupports: [],
};

function StakeholderSupportsFilter({
  selectedStakeholderSupports,
  navigateAction,
}) {
  const selectedCount = selectedStakeholderSupports.length;
  const handleSelect = useCallback(
    (stakeholderSupport) =>
      navigateAction({
        stakeholderSupports: stakeholderSupport
          ? xor(selectedStakeholderSupports, [stakeholderSupport])
          : [],
      }),
    [selectedStakeholderSupports]
  );

  const renderMenuItem = useCallback(
    (stakeholderSupport) => (
      <React.Fragment key={stakeholderSupport}>
        <MenuItem
          active={selectedStakeholderSupports.includes(stakeholderSupport)}
          eventKey={stakeholderSupport}
          onSelect={handleSelect}
        >
          <RatingLabel rating={stakeholderSupport} />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStakeholderSupports]
  );
  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        Stakeholder Support for Change
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="stakeholder-support-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {RATINGS.SUPPORT_LEVELS.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default StakeholderSupportsFilter;
